import React, { Fragment } from "react";
import { utils } from "../../utils/utils";
import { operatorsApiService } from "../../services/api/users/OperatorApiService";
import { fileService } from "../../services/FileService";
import { merchantApiService } from "../../services/api/merchants/MerchantApiService";
import { Roles } from "../../models/AppConstants";
import { storageService } from "../../services/StorageService";

class HeaderLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            mobile: false,
            activeSecondaryMenuMobile: false,
            openLeft: false,
            openRight: false,
            relativeWidth: false,
            width: 280,
            noTouchOpen: false,
            noTouchClose: false,
            photo: null,
        };
    }

    async componentDidMount() {
        const roles = storageService.getRoles();
        if (!roles || roles.length === 0) {
            console.warn("At index.js, Roles not yet available. Skipping Update User Data.");
            return;
        }

        const isSuperAdmin = await this.hasRole(Roles.SUPER_ADMIN);
        const isLeads = await this.hasRole(Roles.MerchantLeads);
        if (!isLeads || isSuperAdmin) {
            await this.updateUserData();
        }
    }

    hasRole = async (role) => {
        return storageService
            .getRoles()
            .map((a) => a.toLowerCase())
            .includes(role.toLowerCase());
    };

    updateUserData = async () => {
        try {
            const userData = await operatorsApiService.get();
            if (!userData.success) {
                return;
            }

            const isMassPaymentExecutor = await this.hasRole(Roles.MassPaymentExecutor);
            
            if (!isMassPaymentExecutor) {
                const merchantData = await merchantApiService.get(userData.data.merchantId);
                if (!merchantData.success) {
                    return;
                }
                let photo = null;
                if (merchantData.data.logo) {
                    const photoResult = await fileService.GetFile(merchantData.data.logo);

                    if (photoResult.success) {
                        photo = photoResult.data;
                    }
                }

                this.setState({ photo });
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    toggleEnableClosedSidebar = () => {
        let { enableClosedSidebar, setEnableClosedSidebar } = this.props;
        setEnableClosedSidebar(!enableClosedSidebar);
    };

    getImageSource = () => {
        if (!this.state?.photo) {
            return (
                <img src="/favicon.svg" className="h-9 w-9 rounded-lg" alt="10n" />
            );
        }

        return (
            <img
                src={utils.appendBase64Data(this.state.photo)}
                className="h-9 max-w-[140px] object-contain"
                alt="Logo"
            />
        );
    };

    render() {
        return (
            <div className="flex items-center px-4 shrink-0">
                {this.getImageSource()}
            </div>
        );
    }
}

export default HeaderLogo;
